import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { ThemeToggle } from "./ThemeToggle";
import { useAuth } from "../lib/auth";

const linkClass = (active: boolean) =>
  [
    "text-xs uppercase-track transition-colors",
    active
      ? "text-[var(--color-kj-text)]"
      : "text-[var(--color-kj-text-light)] hover:text-[var(--color-kj-text)]",
  ].join(" ");

export const AdminLayout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen flex flex-col theme-transition">
      <header className="border-b border-[var(--color-kj-border)] px-8 py-5 flex flex-wrap items-center justify-between gap-4">
        <Link to="/admin" className="font-display text-xl uppercase-track">
          Admin · Kinsey Jones
        </Link>
        <nav className="flex items-center gap-6">
          <NavLink to="/admin" end className={({ isActive }) => linkClass(isActive)}>
            Artworks
          </NavLink>
          <NavLink to="/admin/inquiries" className={({ isActive }) => linkClass(isActive)}>
            Inquiries
          </NavLink>
          <NavLink to="/admin/site" className={({ isActive }) => linkClass(isActive)}>
            Site
          </NavLink>
          <Link
            to="/"
            target="_blank"
            rel="noopener"
            className="text-xs uppercase-track text-[var(--color-kj-text-light)] hover:text-[var(--color-kj-text)] transition-colors"
          >
            View site ↗
          </Link>
          <button
            type="button"
            onClick={handleLogout}
            className="text-xs uppercase-track text-[var(--color-kj-text-light)] hover:text-[var(--color-kj-danger)] transition-colors cursor-pointer"
          >
            Sign out
          </button>
          <ThemeToggle />
        </nav>
      </header>
      <main className="flex-1 max-w-6xl w-full mx-auto px-6 md:px-10 py-10">
        <Outlet />
      </main>
    </div>
  );
};
